module.exports = __webpack_public_path__ + "static/media/T-Rex Costume Man.f1c3b385.jpg";